import React from 'react';

export default function ChevronLeft({className}) {
	return (
        <svg className={className ? className : ''} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 11" preserveAspectRatio="xMidYMid meet"><path data-name="Path 26" d="M0 5.5L5.559 0 7 1.426 2.882 5.5 7 9.574 5.559 11z" fill="#081e64"/></svg>
	);
}
